import SonyFooter from 'components/bolt/footer/sonyFooter.js';

const pixelsCategories = ["PERFORMANCE","TARGETING","STRICTLY_NECESSARY"];

export { SonyFooter };
export { pixelsCategories };